// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subscription_root__6W0uQ {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
  font-size: 16px !important;
}

.Subscription_root__6W0uQ p {
  font-size: 16px !important;
}

.Subscription_subscription_header__cmkQF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-weight: bold;
}

.Subscription_subscription_header_blue__2FHNF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-weight: bold;
  color: var(--color-theme-blue);
}

.Subscription_right_row__RRAjS {
  display: flex;
  align-items: center;
}

.Subscription_right_row__RRAjS div {
  width: 170px;
}

.Subscription_left_row__E61up {
  display: flex;
  align-items: center;
}

.Subscription_content_container__TZqVG {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.Subscription_content_container_blue__FPXzl {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
  color: var(--color-theme-blue);
}

.Subscription_left_container__StU\\+f {
  width: 436px;
  padding: 40px;
}

.Subscription_features_header__ECH9G {
  font-weight: bold;
  padding-bottom: 10px;
}

.Subscription_list_item__H2dfp {
  display: flex;
  width: 360px;
  align-items: center;
}

.Subscription_list_item__H2dfp p {
  padding: 10px;
  font-weight: bold;
}

.Subscription_check_circle_icon__oNu07 {
  width: 14px !important;
  height: 14px !important;
}

.Subscription_right_container__Qbfc\\+ {
  background-color: var(--color-theme-gray);
  width: 100%;
  display: flex;
  padding: 40px;
}

.Subscription_right_container_lite__E3aPh {
  background-color: var(--color-theme-gray);
  width: 100%;
  display: flex;
  padding: 40px;
  justify-content: flex-end;
}

.Subscription_image_container__liR8B {
  display: flex;
}

.Subscription_pro_illustration__an2Zl {
  width: 193px;
  height: 328px;
}

.Subscription_lite_illustration__UF9Wq {
  margin-right: 40px;
  width: 118px;
  height: 265px;
}

.Subscription_enterprise_illustration__sIMcc {
  width: 142px;
  height: 342px;
}

.Subscription_plan__nI5DJ {
  font-weight: bold;
}

.Subscription_plus_circle__Ou1Jq {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 100px;
  left: 420px;
  background-color: var(--color-theme-white);
  border-radius: 100%;
}

.Subscription_rocket_icon__a3S82 {
  width: 28px;
  height: 28px;
  margin-left: 10px;
}

.Subscription_star_icon__slgeZ {
  width: 28px !important;
  height: 28px !important;
  margin-left: 10px;
}

.Subscription_star_icon_blue__q7E10 {
  width: 28px !important;
  height: 28px !important;
  margin-left: 10px;
  color: var(--color-theme-blue) !important;
}

.Subscription_camera_icon__lFBxo {
  margin-left: 10px;
}

.Subscription_btn_upgrade__Aijlf {
  font-weight: bold !important;
  width: 255px;
  height: 37px;
  color: var(--color-theme-steelgray) !important;
  border: 1px solid var(--color-theme-steelgray) !important;
}

.Subscription_btn_upgrade__Aijlf:hover {
  font-weight: bold !important;
  width: 255px;
  height: 37px;
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-black) !important;
}

.Subscription_btn_upgrade_blue__JNeAW {
  font-weight: bold !important;
  width: 255px;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.Subscription_btn_upgrade_blue__JNeAW:hover {
  font-weight: bold !important;
  height: 37px;
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.Subscription_current_plan__N3Nct {
  font-weight: bold;
}

.Subscription_check_icon__6uRl8 {
  margin-left: 10px !important;
}

.Subscription_arrow_icon__Hh-Xa {
  width: 24px !important;
  height: 24px !important;
  color: var(--color-theme-gray-white);
}

.Subscription_info_text__d8bT9 {
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  margin-top: 10px;

}
.Subscription_info_text__d8bT9 p {
  font-size: 13px !important;
  color: var(--color-theme-steelgray);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Subscription/Subscription.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,8CAA8C;EAC9C,yDAAyD;AAC3D;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;;AAElB;AACA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n  font-size: 16px !important;\n}\n\n.root p {\n  font-size: 16px !important;\n}\n\n.subscription_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  font-weight: bold;\n}\n\n.subscription_header_blue {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  font-weight: bold;\n  color: var(--color-theme-blue);\n}\n\n.right_row {\n  display: flex;\n  align-items: center;\n}\n\n.right_row div {\n  width: 170px;\n}\n\n.left_row {\n  display: flex;\n  align-items: center;\n}\n\n.content_container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n}\n\n.content_container_blue {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n  color: var(--color-theme-blue);\n}\n\n.left_container {\n  width: 436px;\n  padding: 40px;\n}\n\n.features_header {\n  font-weight: bold;\n  padding-bottom: 10px;\n}\n\n.list_item {\n  display: flex;\n  width: 360px;\n  align-items: center;\n}\n\n.list_item p {\n  padding: 10px;\n  font-weight: bold;\n}\n\n.check_circle_icon {\n  width: 14px !important;\n  height: 14px !important;\n}\n\n.right_container {\n  background-color: var(--color-theme-gray);\n  width: 100%;\n  display: flex;\n  padding: 40px;\n}\n\n.right_container_lite {\n  background-color: var(--color-theme-gray);\n  width: 100%;\n  display: flex;\n  padding: 40px;\n  justify-content: flex-end;\n}\n\n.image_container {\n  display: flex;\n}\n\n.pro_illustration {\n  width: 193px;\n  height: 328px;\n}\n\n.lite_illustration {\n  margin-right: 40px;\n  width: 118px;\n  height: 265px;\n}\n\n.enterprise_illustration {\n  width: 142px;\n  height: 342px;\n}\n\n.plan {\n  font-weight: bold;\n}\n\n.plus_circle {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  top: 100px;\n  left: 420px;\n  background-color: var(--color-theme-white);\n  border-radius: 100%;\n}\n\n.rocket_icon {\n  width: 28px;\n  height: 28px;\n  margin-left: 10px;\n}\n\n.star_icon {\n  width: 28px !important;\n  height: 28px !important;\n  margin-left: 10px;\n}\n\n.star_icon_blue {\n  width: 28px !important;\n  height: 28px !important;\n  margin-left: 10px;\n  color: var(--color-theme-blue) !important;\n}\n\n.camera_icon {\n  margin-left: 10px;\n}\n\n.btn_upgrade {\n  font-weight: bold !important;\n  width: 255px;\n  height: 37px;\n  color: var(--color-theme-steelgray) !important;\n  border: 1px solid var(--color-theme-steelgray) !important;\n}\n\n.btn_upgrade:hover {\n  font-weight: bold !important;\n  width: 255px;\n  height: 37px;\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-black) !important;\n}\n\n.btn_upgrade_blue {\n  font-weight: bold !important;\n  width: 255px;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.btn_upgrade_blue:hover {\n  font-weight: bold !important;\n  height: 37px;\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.current_plan {\n  font-weight: bold;\n}\n\n.check_icon {\n  margin-left: 10px !important;\n}\n\n.arrow_icon {\n  width: 24px !important;\n  height: 24px !important;\n  color: var(--color-theme-gray-white);\n}\n\n.info_text {\n  display: flex;\n  justify-content: flex-end;\n  font-size: 13px;\n  margin-top: 10px;\n\n}\n.info_text p {\n  font-size: 13px !important;\n  color: var(--color-theme-steelgray);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Subscription_root__6W0uQ`,
	"subscription_header": `Subscription_subscription_header__cmkQF`,
	"subscription_header_blue": `Subscription_subscription_header_blue__2FHNF`,
	"right_row": `Subscription_right_row__RRAjS`,
	"left_row": `Subscription_left_row__E61up`,
	"content_container": `Subscription_content_container__TZqVG`,
	"content_container_blue": `Subscription_content_container_blue__FPXzl`,
	"left_container": `Subscription_left_container__StU+f`,
	"features_header": `Subscription_features_header__ECH9G`,
	"list_item": `Subscription_list_item__H2dfp`,
	"check_circle_icon": `Subscription_check_circle_icon__oNu07`,
	"right_container": `Subscription_right_container__Qbfc+`,
	"right_container_lite": `Subscription_right_container_lite__E3aPh`,
	"image_container": `Subscription_image_container__liR8B`,
	"pro_illustration": `Subscription_pro_illustration__an2Zl`,
	"lite_illustration": `Subscription_lite_illustration__UF9Wq`,
	"enterprise_illustration": `Subscription_enterprise_illustration__sIMcc`,
	"plan": `Subscription_plan__nI5DJ`,
	"plus_circle": `Subscription_plus_circle__Ou1Jq`,
	"rocket_icon": `Subscription_rocket_icon__a3S82`,
	"star_icon": `Subscription_star_icon__slgeZ`,
	"star_icon_blue": `Subscription_star_icon_blue__q7E10`,
	"camera_icon": `Subscription_camera_icon__lFBxo`,
	"btn_upgrade": `Subscription_btn_upgrade__Aijlf`,
	"btn_upgrade_blue": `Subscription_btn_upgrade_blue__JNeAW`,
	"current_plan": `Subscription_current_plan__N3Nct`,
	"check_icon": `Subscription_check_icon__6uRl8`,
	"arrow_icon": `Subscription_arrow_icon__Hh-Xa`,
	"info_text": `Subscription_info_text__d8bT9`
};
export default ___CSS_LOADER_EXPORT___;
